import {
    CLEAR_ERRORS,
    NEW_STORY_FAIL,
    NEW_STORY_REQUEST,
    NEW_STORY_RESET,
    NEW_STORY_SUCCESS,
    USER_STORIES_FAIL,
    USER_STORIES_REQUEST,
    USER_STORIES_SUCCESS
} from "../constants/storyConstants";

export const newStoryReducer = (state = { story: {} }, action) => {
    switch (action.type) {
        case NEW_STORY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case NEW_STORY_SUCCESS:
            return {
                loading: false,
                success: true,
                story: action.payload,
            };
        case NEW_STORY_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case NEW_STORY_RESET:
            return {
                ...state,
                success: false,
            };
        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
            };
        default:
            return state;
    }
};

export const userStoriesReducer = (state = { stories: [] }, action) => {
    switch (action.type) {
        case USER_STORIES_REQUEST:
            return {
                loading: true,
            };
        case USER_STORIES_SUCCESS:
            return {
                loading: false,
                stories: action.payload,
            };
        case USER_STORIES_FAIL:
            return {
                loading: false,
                error: action.payload,
            };
        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
            };
        default:
            return state;
    }
};
